module.exports = function getResource(label) {
    let resources = {
        ccReward: 'Credit Card Reward',
        firstPurchase: 'First Purchase',
        remove: 'Remove',
        apply: 'Apply',
        applied: 'Applied',
        exp: 'Exp.'
    };

    return resources[label];
};
